// src/index.js

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n/config'; // Initialize i18n before rendering the app
import App from './App'; // Importa el componente principal App.js (con React Router)
import CookieConsent from './shared/components/CookieConsent';
import errorLogger from './shared/services/errorLogger';

// Prevenir zoom en iOS Safari
const preventZoom = () => {
    let lastTouchEnd = 0;
    let touches = 0;

    // Prevenir doble tap para zoom (solo si no hay elementos interactivos)
    document.addEventListener('touchend', (e) => {
        const now = Date.now();
        const target = e.target;

        // Permitir clicks en elementos interactivos
        if (target && (
            target.tagName === 'INPUT' ||
            target.tagName === 'TEXTAREA' ||
            target.tagName === 'SELECT' ||
            target.tagName === 'BUTTON' ||
            target.tagName === 'A' ||
            target.closest('button') ||
            target.closest('a') ||
            target.closest('[role="button"]')
        )) {
            lastTouchEnd = now;
            return;
        }

        // Prevenir doble tap solo en elementos no interactivos
        if (touches === 1 && now - lastTouchEnd <= 300) {
            e.preventDefault();
        }
        lastTouchEnd = now;
        touches = 0;
    }, false);

    // Contar toques simultáneos para detectar pinch
    document.addEventListener('touchstart', (e) => {
        touches = e.touches.length;
    }, false);

    // Prevenir pinch zoom
    document.addEventListener('gesturestart', (e) => {
        e.preventDefault();
    });

    document.addEventListener('gesturechange', (e) => {
        e.preventDefault();
    });

    document.addEventListener('gestureend', (e) => {
        e.preventDefault();
    });

    // Prevenir zoom con wheel + meta/ctrl
    document.addEventListener('wheel', (e) => {
        if (e.ctrlKey || e.metaKey) {
            e.preventDefault();
        }
    }, { passive: false });
};

// Ejecutar preventZoom al cargar
preventZoom();

// Configurar handlers globales de errores
const setupErrorHandlers = () => {
    // Handler para errores de JavaScript no capturados
    window.onerror = (message, source, lineno, colno, error) => {
        errorLogger.logUnhandledError(message, source, lineno, colno, error);
        // Retornar false para que el error también se muestre en consola
        return false;
    };

    // Handler para promesas rechazadas no manejadas
    window.addEventListener('unhandledrejection', (event) => {
        errorLogger.logUnhandledRejection(event);
    });

    // También capturar errores de recursos (imágenes, scripts, etc.)
    window.addEventListener('error', (event) => {
        // Solo capturar errores de recursos, no errores de JavaScript (ya capturados por onerror)
        if (event.target && event.target !== window) {
            const resourceError = new Error(
                `Resource error: ${event.target.tagName} failed to load`
            );
            resourceError.stack = `Resource: ${event.target.src || event.target.href}`;
            errorLogger.logError(resourceError);
        }
    }, true); // Use capture phase
};

// Configurar handlers de errores antes de renderizar
setupErrorHandlers();

// Usa el nuevo API de React 18 para crear la raíz de la aplicación
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderiza la aplicación en el contenedor 'root' del index.html
root.render(
    <React.StrictMode>
        <>
            <App />
            <CookieConsent />
        </>
    </React.StrictMode>
);